import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import VerifiedIcon from '@mui/icons-material/Verified';
import StarIcon from '@mui/icons-material/Star';
import Rating from '@mui/material/Rating';
import Skeleton from '@mui/material/Skeleton';
import { Section } from './Section';
import { colorPalette } from '@next-common/mui';
export const ReviewComment = ({ ratingIndicator, rating, feedback, buyerLogin, ratingDateString, isLoading }) => {
    if (isLoading) {
        return (React.createElement(Section, { spacing: 1 },
            React.createElement(Stack, { direction: "row", spacing: 1 },
                React.createElement(Skeleton, { variant: "circular", width: 24, height: 24 }),
                React.createElement(Skeleton, { variant: "text", width: "50%" })),
            React.createElement(Skeleton, { variant: "rectangular", height: 24, width: "40%" }),
            React.createElement(Skeleton, { variant: "text", height: 24, width: "60%" }),
            React.createElement(Skeleton, { variant: "text", height: 24, width: "60%" })));
    }
    return (React.createElement(Section, { spacing: 1 },
        React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1 },
            React.createElement(VerifiedIcon, { sx: {
                    color: colorPalette.blue700,
                    fontSize: '12px',
                } }),
            React.createElement(Typography, { sx: {
                    fontWeight: 600,
                    fontsize: '14px',
                } }, ratingIndicator)),
        React.createElement(Rating, { readOnly: true, value: rating, precision: 0.5, emptyIcon: React.createElement(StarIcon, { sx: {
                    color: colorPalette.gray300,
                }, fontSize: "inherit" }), sx: {
                fontSize: '16px',
            } }),
        React.createElement(Stack, { spacing: 1 },
            React.createElement(Typography, { sx: {
                    fontSize: '14px',
                    color: colorPalette.gray900,
                } }, feedback),
            React.createElement(Typography, { sx: {
                    fontSize: '14px',
                    color: colorPalette.gray700,
                } },
                buyerLogin,
                ", le ",
                ratingDateString))));
};
